import { Component } from '@angular/core';
import { IonCard, IonCardContent, IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-skeleton-card-two-columns',
  templateUrl: './skeleton-card-two-columns.component.html',
  styleUrls: ['./skeleton-card-two-columns.component.scss'],
  imports: [IonCard, IonCardContent, IonGrid, IonRow, IonCol, IonSkeletonText],
})
export class SkeletonCardTwoColumnsComponent {
  // constructor() {}
}
